// extracted by mini-css-extract-plugin
module.exports = {"section":"LoadingSpinner_section__hr3AF","spinner":"LoadingSpinner_spinner__semlo"};